import { c as _c } from "react/compiler-runtime";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useMemo } from "react";
import { useIntl } from "react-intl";
import { RangeMetric } from "../filters/metrics/MetricFilter";
import { gradientColors } from "@/styles/theme";
import { METRIC_CONFIG } from "@/utils/metricUtils";
import { NumericRangeDto } from "@/api/generated/models";
function formatValue(value: number): string {
  return Number.isInteger(value) ? String(value) : value.toFixed(1);
}
function formatLabel(value: number, bound: number, narrowedPrefix: string, unit: string): string {
  const marker = value === bound ? `` : `${narrowedPrefix} `;
  return `${marker}${formatValue(value)} ${unit}`;
}
export const GradientLegend = t0 => {
  const $ = _c(38);
  const {
    metric,
    range,
    datasetRange
  } = t0;
  const intl = useIntl();
  const {
    step,
    unit
  } = METRIC_CONFIG[metric];
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== datasetRange || $[1] !== intl || $[2] !== metric || $[3] !== range.max || $[4] !== range.min || $[5] !== step || $[6] !== unit) {
    const unitLabel = intl.formatMessage(unit);
    const min = Math.floor(range.min / step) * step;
    const max = Math.ceil(range.max / step) * step;
    const mid = (min + max) / 2;
    const dsMin = datasetRange ? Math.floor(datasetRange.min / step) * step : min;
    const dsMax = datasetRange ? Math.ceil(datasetRange.max / step) * step : max;
    t4 = gradientColors[metric];
    t1 = formatLabel(min, dsMin, "<", unitLabel);
    let t5;
    if ($[11] !== mid) {
      t5 = formatValue(mid);
      $[11] = mid;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    t2 = `${t5} ${unitLabel}`;
    t3 = formatLabel(max, dsMax, ">", unitLabel);
    $[0] = datasetRange;
    $[1] = intl;
    $[2] = metric;
    $[3] = range.max;
    $[4] = range.min;
    $[5] = step;
    $[6] = unit;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
  }
  let t5;
  if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t5 = {
      min: t1,
      mid: t2,
      max: t3
    };
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = {
      colors: t4,
      labels: t5
    };
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const {
    colors,
    labels
  } = t6;
  const t7 = `Gradient from ${labels.min} to ${labels.max}`;
  let t8;
  if ($[20] !== colors.max || $[21] !== colors.mid || $[22] !== colors.min || $[23] !== t7) {
    t8 = <Box data-testid="legend-gradient-bar" role="img" aria-label={t7} height="4" borderRadius="button" bgGradient="to-r" gradientFrom={colors.min} gradientVia={colors.mid} gradientTo={colors.max} />;
    $[20] = colors.max;
    $[21] = colors.mid;
    $[22] = colors.min;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== labels.min) {
    t9 = <Text data-testid="legend-label-min" fontSize="xs" color="textMuted">{labels.min}</Text>;
    $[25] = labels.min;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== labels.mid) {
    t10 = <Text data-testid="legend-label-mid" fontSize="xs" color="textMuted">{labels.mid}</Text>;
    $[27] = labels.mid;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== labels.max) {
    t11 = <Text data-testid="legend-label-max" fontSize="xs" color="textMuted">{labels.max}</Text>;
    $[29] = labels.max;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t11 || $[33] !== t9) {
    t12 = <Flex justify="space-between" mt="2">{t9}{t10}{t11}</Flex>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t9;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t8) {
    t13 = <Box>{t8}{t12}</Box>;
    $[35] = t12;
    $[36] = t8;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};